import { render, staticRenderFns } from "./CandidateSiteClaimSource.vue?vue&type=template&id=0b3d553c&"
import script from "./CandidateSiteClaimSource.vue?vue&type=script&lang=js&"
export * from "./CandidateSiteClaimSource.vue?vue&type=script&lang=js&"
import style0 from "./CandidateSiteClaimSource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports